export enum LivePageWidgetType {
  MAP = 'MAP',
  VIDEO = 'VIDEO',
}

export enum DrawingOption {
  ALERT = 'ALERT',
  BUILDING = 'BUILDING',
  NO_FLY = 'NO_FLY',
  POI = 'POI',
  GEO_FENCE = 'GEO_FENCE',
  BASE = 'BASE',
  ELZ = 'ELZ',
  WAYPOINT = 'WAYPOINT',
  NULL = 'null',
}

export enum MapFeatureState {
  NEW = 'new',
  UPDATE = 'update',
  NULL = 'null',
}

export enum SocketDrawingOption {
  ICON = 'ICON',
  DIVICON = 'DIVICON',
  CIRCLEMARKER = 'CIRCLEMARKER',
}

export enum UnitSystemOption {
  METRIC = 'METRIC',
  IMPERIAL = 'IMPERIAL',
}

export enum TempUnitOption {
  FAHRENHEIT = 'FAHRENHEIT',
  CELSIUS = 'CELSIUS',
}

export enum SpeedUnitOption {
  KPH = 'KPH',
  MPH = 'MPH',
}

export enum VideoPlayerOption {
  WEBRTC = 'WEBRTC',
  HLS = 'HLS',
}

export enum VideoStreamOption {
  THERMAL = 'THERMAL',
  RGB = 'RGB',
}

export enum VideoDefinition {
  HD = 'HD',
  SD = 'SD',
}

export enum PiPModeOption {
  NONE = 'NONE',
  RGB = 'RGB',
  THERMAL = 'THERMAL',
}

interface UserRole {
  level: number;
  title: string;
  protected?: boolean;
  created?: boolean;
}

export const UserRoles: UserRole[] = [
  {
    title: 'Robot',
    level: 0,
  },
  {
    title: 'Wingman',
    level: 1,
  },
  {
    title: 'Pilot',
    level: 2,
  },
  {
    title: 'Captain',
    level: 3,
  },
  {
    title: 'Admin',
    level: 4,
  },
  {
    title: 'SuperUser',
    level: 9001,
  },
];

export enum DroneCommands {
  RTB = 'RTB',
  ELZ = 'ELZ',
  GAZE = 'GAZE',
  FLY_TO = 'FLY_TO',
  ORBIT = 'ORBIT',
}

export enum Direction {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  UP = 'UP',
  DOWN = 'DOWN',
  FORWARD = 'FORWARD',
  BACKWARD = 'BACKWARD',
  YAW_LEFT = 'YAW_LEFT',
  YAW_RIGHT = 'YAW_RIGHT',
}

export const TOAST_DEFAULT_DURATION = 5000; // ms

export const TOAST_WARNING_DURATION = 10000; // ms

export const VIDEO_OFFSET_DURATION = 8000;

export const WEEKDAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const WEEKDAY_FULL = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const RGB_ZOOM_LEVELS: { label: string; value: number }[] = [
  {
    label: '1x',
    value: 0,
  },
  {
    label: '2x',
    value: 1,
  },
  {
    label: '3x',
    value: 2,
  },
  {
    label: '4x',
    value: 3,
  },
  {
    label: '6x',
    value: 4,
  },
];

export const THERMAL_ZOOM_LEVELS: { label: string; value: number }[] = [
  {
    label: '1x',
    value: 0,
  },
  {
    label: '2x',
    value: 1,
  },
  {
    label: '3x',
    value: 2,
  },
  {
    label: '4x',
    value: 3,
  },
];

// Map camera version to RGB zoom levels
export const RGB_ZOOM_LABELS_BY_VERSION: Record<string, number[]> = {
  '1': [1, 2, 3, 4, 5, 6, 7], // Camera version 1
  '2': [1, 2, 3, 4, 8, 16, 24, 32], // Camera version 2
};
export const MAX_THERMAL_ZOOM_LEVEL = 3;
export const MIN_ZOOM_LEVEL = 0;

export enum HeadingDirectionsShort {
  NORTH = 'N',
  NORTHEAST = 'NE',
  EAST = 'E',
  SOUTHEAST = 'SE',
  SOUTH = 'S',
  SOUTHWEST = 'SW',
  WEST = 'W',
  NORTHWEST = 'NW',
}
// mph
export const WAYPOINT_SPEED_SLOW_MIN_IMPERIAL = 1;
export const WAYPOINT_SPEED_FAST_MAX_IMPERIAL = 35;

// kph
export const WAYPOINT_SPEED_SLOW_MIN_METRIC = 1.6;
export const WAYPOINT_SPEED_FAST_MAX_METRIC = 56.3;

export const DURATION_MAX_SECONDS = 7200;
export const MAX_ALTITUDE = 99999;

export const ELZ_CIRCLE_RADIUS = 10;

export const ORBIT_CIRCLE_RADIUS = 30;

export const ORBIT_CIRCLE_ALTITUDE = 30;

export const PASSWORDCONFIG: any = [
  {
    id: 0,
    value: 'Too Weak',
    minDiversity: 0,
    minLength: 0,
  },
  {
    id: 1,
    value: 'Too Weak',
    minDiversity: 0,
    minLength: 4,
  },
  {
    id: 2,
    value: 'Weak',
    minDiversity: 1,
    minLength: 6,
  },
  {
    id: 3,
    value: 'Medium',
    minDiversity: 2,
    minLength: 8,
  },
  {
    id: 4,
    value: 'Good',
    minDiversity: 3,
    minLength: 10,
  },
  {
    id: 5,
    value: 'Strong',
    minDiversity: 4,
    minLength: 12,
  },
];

export const BVLOS_TRIGGER_DISTANCE_METERS = 8000; // 8km in meters or roughly 5 miles
export const BVLOS_TRIGGER_ALTITUDE_AGL = 915; // 915 meters currently in MSL because of data constraints, refer to asana task
export const LOW_BATTERY_THRESHHOLD = 20;

export const LIVE_PAGE_WIDGET_SIZES = {
  default: {
    width: 475,
    height_RGB: 267,
    height_Thermal: 380,
    height_map: 267,
  },
  minimum: {
    width: 460,
    height_RGB: 259,
    height_Thermal: 368,
    height_map: 150,
  },
};

export const LIVE_PAGE_WIDGET_STACK_BREAKPOINT_WIDTH = 1280; // 1280px - when the width is below this, the map and video will be stacked vertically instead of overlapping when the map is the widget

export const RIGHT_TOOLBAR_WIDTH = 64; // Width of the right toolbar on the Live page in pixels
export const TOP_NAVBAR_HEIGHT = 64; // Height of the top navbar in pixels
export const VIDEO_ZOOM_CONTROLS_HEIGHT = 48; // Height of the video zoom controls on the Live page in pixels
export const VIDEO_ASPECT_RATIO_RGB = 16 / 9; // Video player's aspect ratio is 16:9 in RGB mode
export const VIDEO_ASPECT_RATIO_THERMAL = 5 / 4; // Video player's aspect ratio is 5:4 in Thermal mode

export const LEFT_NAV_WIDTH_EXPANDED = 320; // Width of the left nav when EXPANDED on the Live page in px
export const LEFT_NAV_WIDTH_CLOSED = 64; // Width of the left nav when CLOSED on the Live page in px

export const LIVE_PAGE_WIDGET_TOP_NAVBAR_GAP = 4; // Gap between the top of the widget on the Live page and the bottom of the top navbar in pixels
export const LIVE_PAGE_WIDGET_RIGHT_TOOLBAR_GAP = 4; // Gap between the right side of the widget on the Live page and the page's right toolbar in pixels

export enum Command {
  LEFT = 'LEFT',
  LEFT_REL = 'LEFT_REL',
  RIGHT = 'RIGHT',
  RIGHT_REL = 'RIGHT_REL',
  UP = 'UP',
  UP_REL = 'UP_REL',
  DOWN = 'DOWN',
  DOWN_REL = 'DOWN_REL',
  FORWARD = 'FORWARD',
  FORWARD_REL = 'FORWARD_REL',
  BACKWARD = 'BACKWARD',
  BACKWARD_REL = 'BACKWARD_REL',
  CAMERA_PITCH_UP = 'CAMERA_PITCH_UP',
  CAMERA_PITCH_UP_REL = 'CAMERA_PITCH_UP_REL',
  CAMERA_PITCH_DOWN = 'CAMERA_PITCH_DOWN',
  CAMERA_PITCH_DOWN_REL = 'CAMERA_PITCH_DOWN_REL',
  CAMERA_YAW_LEFT = 'CAMERA_YAW_LEFT',
  CAMERA_YAW_LEFT_REL = 'CAMERA_YAW_LEFT_REL',
  CAMERA_YAW_RIGHT = 'CAMERA_YAW_RIGHT',
  CAMERA_YAW_RIGHT_REL = 'CAMERA_YAW_RIGHT_REL',
  NOTES = 'NOTES',
  HELP = 'HELP',
  RGB_ZOOM_1 = 'RGB_ZOOM_1',
  RGB_ZOOM_2 = 'RGB_ZOOM_2',
  RGB_ZOOM_3 = 'RGB_ZOOM_3',
  RGB_ZOOM_4 = 'RGB_ZOOM_4',
  RGB_ZOOM_5 = 'RGB_ZOOM_5',
  RGB_ZOOM_6 = 'RGB_ZOOM_6',
  RGB_ZOOM_7 = 'RGB_ZOOM_7',
  THERMAL_ZOOM_1 = 'THERMAL_ZOOM_1',
  THERMAL_ZOOM_2 = 'THERMAL_ZOOM_2',
  THERMAL_ZOOM_3 = 'THERMAL_ZOOM_3',
  THERMAL_ZOOM_4 = 'THERMAL_ZOOM_4',
  PICTURE_IN_PICTURE = 'PICTURE_IN_PICTURE',
  SWITCH_VIDEO_VIEW = 'SWITCH_VIDEO_VIEW',
  ZOOM_LEVEL_LOWER = 'ZOOM_LEVEL_LOWER',
  ZOOM_LEVEL_HIGHER = 'ZOOM_LEVEL_HIGHER',
  ZOOM_LEVEL_HIGHER_SECONDARY = 'ZOOM_LEVEL_HIGHER_SECONDARY', // this was added to allow both '=' and '+' to be used for zooming in - in the future, these can be combined into one command
  GIMBAL_MOUSE_MOVEMENT = 'GIMBAL_MOUSE_MOVEMENT',
  HEADING = 'HEADING',
  TILT = 'TILT',
  HOVER = 'HOVER',
  RESUME = 'RESUME',
  FLY_TO = 'FLY_TO',
  CIRCLE = 'CIRCLE',
  ORBIT = 'ORBIT',
  NEXT_WP = 'NEXT_WP',
  SET_GAZE = 'SET_GAZE',
  CLEAR_GAZE = 'CLEAR_GAZE',
  RTB = 'RTB',
  ELZ = 'ELZ',
  DODGE = 'DODGE',
  GIMBAL_MOUSE_CONTROL = 'GIMBAL_MOUSE_CONTROL',
}

export const HOTKEY_REPEAT_INTERVAL = 500; // 500 ms - how often a hotkey is fired when you hold its button down
export const HOTKEY_VISUALS_DURATION = 1000; // 1 second
export const GIMBAL_MOVEMENT_FREQUENCY = 500; // 500 milliseconds - how often the gimbal mouse control sends updates to BES
export const GIMBAL_ANIMATION_RETURN_VIRTUAL_VAL_BALL_TO_CENTER_SPEED = 0.01;

export const PASSWORD_STRENGTH_LABELS = [
  '', // level 0 (empty)
  'Too Weak', // level 1
  'Weak', // level 2
  'Medium', // level 3
  'Good', // level 4
  'Strong', // level 5
];
export const MINIMUM_PASSWORD_LENGTH = 10;
export const MINIMUM_PASSWORD_STRENGTH_LEVEL = 4;

export const DFR_EVENT_MAX_AGE = 30 * 60 * 1000; // 30 minutes - any DFR event with a timestamp older than this will not be displayed on the MissionMap on the Live page
export const DFR_BUFFER_PROCESS_INTERVAL_SHORT = 0 * 1000; // 0 seconds - the time in between each event in the Live page's dfrBuffer being processed - this is used when there's less than 10 dfrs on the page
export const DFR_BUFFER_PROCESS_INTERVAL_LONG = 0 * 1000; // 0 seconds - the time in between each event in the Live page's dfrBuffer being processed - this is used when there's 10 or more dfrs on the page

export const DRONE_STATUS_DATA_STALE_THRESHOLD = 30 * 1000; // 30 seconds - if the drone status data is older than this, the status is considered outdated

export const NO_DRONE_SELECTED_TOAST_MESSAGE =
  'No drone is selected. Please select a drone.';

export const ACTIVE_MISSION_ALERT_MODAL_PADDING = 4; // px of padding around the draggable area for the ActiveMissionAlertModal

// cropping values for 32x zoom level for block5
export const THIRTYTWO_X_ZOOM_LEVEL_CROP_LEFT = 1647;
export const THIRTYTWO_X_ZOOM_LEVEL_CROP_RIGHT = 2195;
export const THIRTYTWO_X_ZOOM_LEVEL_CROP_BOTTOM = 1235;
export const THIRTYTWO_X_ZOOM_LEVEL_CROP_TOP = 927;

// password strength constant
export const MAX_PASSWORD_STRENGTH_LEVEL = 5;

// --------------------------- Compass Component Constants ---------------------------
// BOTTOM HUD COMPASS values
export const COMPASS_SECTOR_DEGREES = 22.5;
export const COMPASS_DIRECTIONS_COUNT = 16;

// Activity Log Side Panel Size
export const SIDE_PANEL_MIN_WIDTH = 300;
export const SIDE_PANEL_STANDARD_WIDTH = 375;
export const SIDE_PANEL_MAX_WIDTH = 600;

export const COMPASS_DEGREE_STEP = 5;
export const COMPASS_MAJOR_STEP = 15;
export const COMPASS_STRIP_HEIGHT = 44; // height of the compass strip in px

// Compass component constants
export const TICK_SPACING = 24; // px per 5 degrees
